import moment from 'moment'

import {
    ClassicEditor,
    AccessibilityHelp,
    Autoformat,
    AutoImage,
    Autosave,
    Base64UploadAdapter,
    BlockQuote,
    Bold,
    Essentials,
    Heading,
    ImageBlock,
    ImageCaption,
    ImageInline,
    ImageInsert,
    ImageInsertViaUrl,
    ImageResize,
    ImageStyle,
    ImageTextAlternative,
    ImageToolbar,
    ImageUpload,
    Indent,
    IndentBlock,
    Italic,
    Link,
    LinkImage,
    List,
    ListProperties,
    Markdown,
    MediaEmbed,
    Paragraph,
    PasteFromMarkdownExperimental,
    PasteFromOffice,
    SelectAll,
    Table,
    TableCaption,
    TableCellPropertiesUI,
    TableColumnResize,
    TableProperties,
    TableToolbar,
    TextTransformation,
    TodoList,
    Underline,
    Undo,
    Alignment,
    FontColor,
    FontFamily,
    FontSize,
    FontBackgroundColor,
} from 'ckeditor5';


export const getShowingMonthDateYear = (dateStr) => {
    return moment(dateStr).format("MM/DD/YYYY")
}

export const getShowingDateText = (dateStr) => {
    return moment(dateStr)?.format("MM/DD/yyyy")
}


export const customStyles = {
    header: {
        style: {
            padding: '10px 15px', 
            fontSize: '16px',
            backgroundColor: '#f7f7f7',
        },
    },
    rows: {
        style: {
            minHeight: '50px',
            
            '&:not(:last-of-type)': {
             
               
                
            },
        },
    },
    headCells: {
        style: {
            padding: '10px 15px',
            fontWeight: 'bold',
            backgroundColor: '#04142e',
            color: "white",
            border: '1px solid #ccc',
            paddingLeft: '8px',
            paddingRight: '8px',
            justifyContent: 'center',
            textAlign: 'center',
 
 
        },
    },
    cells: {
        style: {
            padding: '10px 15px',
            borderBottom: '1px solid #ccc',
            borderRight: '1px solid #ccc',
            borderLeft: '1px solid #ccc',
            paddingLeft: '8px',
            paddingRight: '8px',
            justifyContent: 'center',
            textAlign: 'center',
        },
    },
    pagination: {
        style: {
            padding: '10px 15px',
        },
    },
};
 
 
export const editorConfig = {
    isSpellCheckEnabled: true,
    spellChecker: {
        language: 'en', 
        serverURL: 'https://spellcheck.example.com', 
    },
    toolbar: {
        items: [
            'undo',
            'redo',
            '|',
            'heading',
            '|',
            'bold',
            'italic',
            'underline',
            '|',
            'link',
            'insertImage',
            'mediaEmbed',
            'insertTable',
            'blockQuote',
            '|',
            'bulletedList',
            'numberedList',
            'todoList',
            'outdent',
            'indent',
            'spellCheck',
            '|',
            'alignment',
            'fontFamily',
            'fontSize',
            'fontColor',
            'fontBackgroundColor',
        ],
        shouldNotGroupWhenFull: false,
    },
    allowedContent: true, 
    removePlugins: ["Markdown"], 
    plugins: [
        AccessibilityHelp,
        Autoformat,
        AutoImage,
        Autosave,
        Base64UploadAdapter,
        BlockQuote,
        Bold,
        Essentials,
        Heading,
        ImageBlock,
        ImageCaption,
        ImageInline,
        ImageInsert,
        ImageInsertViaUrl,
        ImageResize,
        ImageStyle,
        ImageTextAlternative,
        ImageToolbar,
        ImageUpload,
        Indent,
        IndentBlock,
        Italic,
        Alignment,
        Link,
        LinkImage,
        List,
        ListProperties,
        MediaEmbed,
        Paragraph,
        PasteFromOffice,
        SelectAll,
        Table,
        TableCaption,
        TableColumnResize,
        TableToolbar,
        TextTransformation,
        TodoList,
        Underline,
        Undo,
        FontColor,
        FontFamily,
        FontBackgroundColor,
    ],
    heading: {
        options: [
            { model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph' },
            { model: 'heading1', view: 'h1', title: 'Heading 1', class: 'ck-heading_heading1' },
            { model: 'heading2', view: 'h2', title: 'Heading 2', class: 'ck-heading_heading2' },
            { model: 'heading3', view: 'h3', title: 'Heading 3', class: 'ck-heading_heading3' },
            { model: 'heading4', view: 'h4', title: 'Heading 4', class: 'ck-heading_heading4' },
            { model: 'heading5', view: 'h5', title: 'Heading 5', class: 'ck-heading_heading5' },
            { model: 'heading6', view: 'h6', title: 'Heading 6', class: 'ck-heading_heading6' },
        ],
    },
    image: {
        toolbar: [
            'toggleImageCaption',
            'imageTextAlternative',
            '|',
            'imageStyle:inline',
            'imageStyle:wrapText',
            'imageStyle:breakText',
            '|',
            'resizeImage',
        ],
    },
    link: {
        addTargetToExternalLinks: true,
        defaultProtocol: 'https://',
        decorators: {
            toggleDownloadable: {
                mode: 'manual',
                label: 'Downloadable',
                attributes: { download: 'file' },
            },
        },
    },
    list: {
        properties: {
            styles: true,
            startIndex: true,
            reversed: true,
        },
    },
    placeholder: 'Type or paste your content here!',
    table: {
        contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells'],
    },
};





export const ReactQuillModules = {
    toolbar: [
        [{ 'header': [1, 2, false] }],
        ['bold', 'italic', 'underline', 'strike', 'blockquote'],
        [{ 'list': 'ordered' }, { 'list': 'bullet' }, { 'indent': '-1' }, { 'indent': '+1' }],
        ['link', 'image'],
        ['clean']
    ],
    clipboard: {
       
        matchVisual: true,
      
        matchHtml: true,
      
        preserveStyles: true,
       
        preserveLineBreaks: true,
       
        preserveLinks: true,
     
        preserveImages: true
    }
};

export const ReactQuillFormats = [
    'header',
    'bold', 'italic', 'underline', 'strike', 'blockquote',
    'list', 'bullet', 'indent',
    'link', 'image'
];